import { render, staticRenderFns } from "./AccordionManageAccount.vue?vue&type=template&id=622fe872&scoped=true"
import script from "./AccordionManageAccount.vue?vue&type=script&lang=js"
export * from "./AccordionManageAccount.vue?vue&type=script&lang=js"
import style0 from "./AccordionManageAccount.vue?vue&type=style&index=0&id=622fe872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fe872",
  null
  
)

export default component.exports